module.exports = __webpack_public_path__ + "img/SKMJ_ladder6.ca54675c.jpg";